import {
  HStack,
  VStack,
  Text,
  Image,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';

interface FooterProps {
  organizationLogo: string;
  organizationName: string;
}

const Footer = ({ organizationLogo, organizationName }: FooterProps) => {
  const cardBg = useColorModeValue('gray.50', 'gray.700');

  return (
    <Card bg={cardBg} p={6}>
      <VStack spacing={3}>
        <HStack spacing={2} justify="center" flexWrap="wrap">
          <Image
            src={organizationLogo}
            alt={`${organizationName} logo`}
            maxH="30px"
            maxW="120px"
            objectFit="contain"
          />
        </HStack>
        <HStack
          spacing={4}
          fontSize="xs"
          color="gray.500"
          flexWrap="wrap"
          justify="center"
        >
          <Text>Secure Document Upload</Text>
          <Text>•</Text>
          <Text>
            © {new Date().getFullYear()} {organizationName}
          </Text>
        </HStack>
      </VStack>
    </Card>
  );
};

export default Footer;
